/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class SnapchatOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    {...this.props}
                    error={this.props.error}
                    headerCopy="Select a Snapchat Profile"/>
                <ChooserMain
                    {...this.props}
                    allConnectedMessage={(
                        <p className="chooser-notice">You've already connected all your Snapchat profiles to dlvr.it</p>
                    )}
                    typeLabel="Snapchat Profile"/>
            </div>
        );
    }
}

SnapchatOutput.displayName = "SnapchatOutput";

export default SnapchatOutput;
